// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Header from '../../Header';
import Footer from '../../Footer';
import config from '../../common/Config';
import { Box, Typography, TextField, Button, Paper, Tabs, Tab, Grid2, Autocomplete, Chip } from '@mui/material';
import { toast } from 'sonner';
import '../../common/commonStyles.css';
import { postEditUser, axiosPostUsersMultipart } from '../../../utils/usersApi';

const TabPanel = ({ children, value, index }) =>
  value === index ? <Box sx={{ pt: 2 }}>{children}</Box> : null;

const User_Profile = () => {
  const { userId } = useParams();
  // const navigateToUserList = useNavigate();
  const token = localStorage.getItem('token');
  const accessToken = localStorage.getItem('accessToken');
  // const modalRef = useRef(null);
  // const [userRoles, setUserRoles] = useState([]);
  const [errors, setErrors] = useState({});
  const [privacyErrors, setPrivacyErrors] = useState({});
  const [formData, setFormData] = useState({
    id: '',
    avatar: '',
    username: '',
    email: '',
    group: [],
    first_name: '',
    last_name: '',
    address: '',
    postcode: '',
    city: '',
    state: '',
    mobile: '',
    image: '',
  });
  const [roleOptions, setRoleOptions] = useState([]);
  const [tabValue, setTabValue] = useState(0);

  const fetchUserRoles = async () => {
    const apiUserRolesUrl = `${config.API_URL}/get_users_role`;
    try {
      const response = await fetch(apiUserRolesUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const formattedOptions = (data.data || []).map((item) => ({
        key: `${item.name}`,
        value: `${item.id}`,
      }));
      setRoleOptions(formattedOptions);
    } catch {
    }
  };

  const fetchUserInfo = async () => {
    const apiUseInfoUrl = `${config.API_URL}/edit_users`;
    try {
      const data = await postEditUser(apiUseInfoUrl, token, userId);
      if (!data?.success || !data?.data) {
        toast.error('Could not load user');
        return;
      }
      const rolesArray = data.data.id_roles
        ? data.data.id_roles.split(',').map((role) => role.trim())
        : [];
      setFormData((prevFormData) => ({
        ...prevFormData,
        id: data.data.id,
        avatar: data.data.avatar,
        username: data.data.username,
        email: data.data.email,
        group: rolesArray,
        first_name: data.data.first_name,
        last_name: data.data.last_name,
        address: data.data.address,
        postcode: data.data.postcode,
        city: data.data.city,
        state: data.data.state,
        mobile: data.data.phone,
        image: data.data.image,
      }));
    } catch {
      toast.error('Could not load user');
    }
  };

  useEffect(() => {
    if (!accessToken) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    fetchUserRoles();
    if (userId) {
      fetchUserInfo();
    }
  }, [accessToken, userId]);

  const handleChangeRole = (event, newValue) => {
    const selectedValues = newValue.map((option) => option.value);
    setFormData((prevFormData) => ({
      ...prevFormData,
      group: selectedValues,
    }));
    setErrors((prev) => ({ ...prev, group: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.first_name) {
      newErrors.first_name = 'Mention Name.';
    } else if (formData.first_name.length < 2) {
      newErrors.first_name = 'name must consist of at least 2 characters.';
    } else if (formData.first_name.length > 255) {
      newErrors.first_name = 'name must not exceed 255 characters.';
    }
    if (!formData.last_name) {
      newErrors.last_name = 'Mention Name.';
    } else if (formData.last_name.length < 2) {
      newErrors.last_name = 'name must consist of at least 2 characters.';
    } else if (formData.last_name.length > 255) {
      newErrors.last_name = 'name must not exceed 255 characters.';
    }
    if (!formData.email) {
      newErrors.email = 'Mention Email Id.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email.';
    }
    if (!formData.group || formData.group.length === 0) {
      newErrors.group = 'Select at least one role.';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    let fieldErrors = {};
    switch (name) {
      case 'first_name':
        if (!value) fieldErrors.first_name = 'Mention Name.';
        else if (value.length < 2) fieldErrors.first_name = 'name must consist of at least 2 characters.';
        else if (value.length > 255) fieldErrors.first_name = 'name must not exceed 255 characters.';
        if (!fieldErrors.first_name) fieldErrors.first_name = '';
        break;
      case 'last_name':
        if (!value) fieldErrors.last_name = 'Mention Name.';
        else if (value.length < 2) fieldErrors.last_name = 'name must consist of at least 2 characters.';
        else if (value.length > 255) fieldErrors.last_name = 'name must not exceed 255 characters.';
        if (!fieldErrors.last_name) fieldErrors.last_name = '';
        break;
      case 'email':
        if (!value) fieldErrors.email = 'Mention Email Id.';
        else if (!/\S+@\S+\.\S+/.test(value)) fieldErrors.email = 'Please enter a valid email.';
        if (!fieldErrors.email) fieldErrors.email = '';
        break;
      default:
        break;
    }
    setErrors((prevErrors) => ({ ...prevErrors, ...fieldErrors }));
  };

  const submitUpdateUserForm = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;
    const form = document.getElementById('updateuserform');
    const formDataObj = new FormData(form);
    formDataObj.delete('group[]');
    if (formData.group && formData.group.length > 0) {
      formData.group.forEach((roleId) => {
        formDataObj.append('group[]', roleId);
      });
    }
    try {
      const result = await axiosPostUsersMultipart(
        `${config.API_URL}/update_users`,
        token,
        formDataObj
      );
      if (result.success == true) {
        toast.success('User updated successfully.');
        window.location.href = config.BASE_URL + '/users';
      } else {
        toast.error('User updated Failed. Try Again');
      }
    } catch (error) {
      if (error.message === 'ENCRYPT_KEY_MISSING') {
        toast.error('Encryption key missing.');
      } else {
        toast.error('An error occurred while updating user.');
      }
    }
  };

  const [formPrivacyData, setFormPrivacyData] = useState({
    currentPassword: '',
    password: '',
    confpass: '',
  });

  const validatePrivacyForm = () => {
    const newPrivacyErrors = {};
    if (!formPrivacyData.currentPassword) {
      newPrivacyErrors.currentPassword = 'Mention Password.';
    } else if (formPrivacyData.currentPassword.length < 6) {
      newPrivacyErrors.currentPassword = 'Password must consist of at least 6 digits.';
    } else if (formPrivacyData.currentPassword.length > 255) {
      newPrivacyErrors.currentPassword = 'Password must not exceed 6 digits.';
    }
    if (!formPrivacyData.password) {
      newPrivacyErrors.password = 'Mention Password.';
    } else if (formPrivacyData.password.length < 6) {
      newPrivacyErrors.password = 'Password must consist of at least 6 digits.';
    } else if (formPrivacyData.password.length > 6) {
      newPrivacyErrors.password = 'Password must not exceed 6 digits.';
    }
    if (!formPrivacyData.confpass) {
      newPrivacyErrors.confpass = 'Please confirm your password.';
    } else if (formPrivacyData.confpass !== formPrivacyData.password) {
      newPrivacyErrors.confpass = 'Passwords do not match.';
    }
    setPrivacyErrors(newPrivacyErrors);
    return Object.keys(newPrivacyErrors).length === 0;
  };

  const handlePrivacyChange = (e) => {
    const { name, value } = e.target;
    setFormPrivacyData({ ...formPrivacyData, [name]: value });
  };

  const submitPrivacyForm = async (e) => {
    e.preventDefault();
    if (!validatePrivacyForm()) return;
    const formData = new FormData();
    formData.append('id', userId);
    formData.append('currentPassword', formPrivacyData.currentPassword);
    formData.append('password', formPrivacyData.password);
    formData.append('confpass', formPrivacyData.confpass);
    try {
      const response = await axios.post(`${config.API_URL}/update_password`, formData, {
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });
      const res = response.data;
      if (res.success === true) {
        toast.success(res.message || 'Password updated.');
        setFormPrivacyData({ currentPassword: '', password: '', confpass: '' });
      } else {
        toast.error(res.message || 'Password update failed.');
      }
    } catch {
      toast.error('Password update failed.');
    }
  };

  const selectedRoleOptions = roleOptions.filter((opt) => formData.group.includes(String(opt.value)));

  return (
    <>
      <Box className="page-container">
        <Paper elevation={0} className="paper-style">
          <Box sx={{ px: 2, py: 1.2 }}>
            <Typography className="page-title" >
              Edit User
            </Typography>
            <Tabs className="common-tabs" value={tabValue} onChange={(_, v) => setTabValue(v)}>
              <Tab label="Account" />
              <Tab label="Privacy" />
            </Tabs>

            <TabPanel value={tabValue} index={0}>
              <Box component="form" id="updateuserform" onSubmit={submitUpdateUserForm}>
                <input type="hidden" name="id" value={formData.id} />
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12 }}>
                    {formData.image || formData.avatar ? (
                      <Grid2 size={{ xs: 12, sm: 6 }}>
                        <Box
                          component="img"
                          src={formData.image || formData.avatar}
                          alt=""
                          sx={{ maxWidth: 120, borderRadius: 1 }}
                        />
                      </Grid2>
                    ) : null}

                    <Grid2 size={{ xs: 12, sm: 6 }}>
                      <Button variant="outlined" component="label" sx={{ textTransform: 'none' }}>
                        Change avatar
                        <input id="avatar" name="avatar" type="file" accept="image/*" hidden />
                      </Button>
                    </Grid2>
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }}>
                    <TextField
                      className="form-input-border"
                      fullWidth
                      size="small"
                      label="Username"
                      name="username"
                      value={formData.username}
                      InputProps={{ readOnly: true }}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6 }}>
                    <TextField
                      className="form-input-border"
                      fullWidth
                      size="small"
                      label="Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      error={!!errors.email}
                      helperText={errors.email}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12 }}>
                    <Autocomplete
                      multiple
                      options={roleOptions}
                      getOptionLabel={(o) => o.key}
                      value={selectedRoleOptions}
                      onChange={handleChangeRole}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          label="Roles"
                          error={!!errors.group}
                          helperText={errors.group}
                        />
                      )}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip {...getTagProps({ index })} key={option.value} label={option.key} size="small" />
                        ))
                      }
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6 }}>
                    <TextField
                      className="form-input-border"
                      fullWidth
                      size="small"
                      label="First name"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChange}
                      error={!!errors.first_name}
                      helperText={errors.first_name}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6 }}>
                    <TextField
                      className="form-input-border"
                      fullWidth
                      size="small"
                      label="Last name"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleChange}
                      error={!!errors.last_name}
                      helperText={errors.last_name}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6 }}>
                    <TextField
                      className="form-input-border"
                      fullWidth
                      size="small"
                      label="Mobile"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12 }}>
                    <TextField
                      className="form-input-border"
                      fullWidth
                      size="small"
                      label="Address"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 4 }}>
                    <TextField
                      className="form-input-border"
                      fullWidth
                      size="small"
                      label="Postcode"
                      name="postcode"
                      value={formData.postcode}
                      onChange={handleChange}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 4 }}>
                    <TextField
                      className="form-input-border"
                      fullWidth
                      size="small"
                      label="City"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 4 }}>
                    <TextField
                      className="form-input-border"
                      fullWidth
                      size="small"
                      label="State"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12 }}>
                    <Button type="submit" variant="contained" className="button-variant-contained" sx={{ textTransform: 'none' }}>
                      Update user
                    </Button>
                  </Grid2>
                </Grid2>
              </Box>
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
              <Box component="form" onSubmit={submitPrivacyForm}>
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, sm: 6 }}>
                    <TextField
                      className="form-input-border"
                      fullWidth
                      size="small"
                      type="password"
                      label="Current password"
                      name="currentPassword"
                      value={formPrivacyData.currentPassword}
                      onChange={handlePrivacyChange}
                      error={!!privacyErrors.currentPassword}
                      helperText={privacyErrors.currentPassword}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6 }}>
                    <TextField
                      className="form-input-border"
                      fullWidth
                      size="small"
                      type="password"
                      label="New password"
                      name="password"
                      value={formPrivacyData.password}
                      onChange={handlePrivacyChange}
                      error={!!privacyErrors.password}
                      helperText={privacyErrors.password}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6 }}>
                    <TextField
                      className="form-input-border"
                      fullWidth
                      size="small"
                      type="password"
                      label="Confirm password"
                      name="confpass"
                      value={formPrivacyData.confpass}
                      onChange={handlePrivacyChange}
                      error={!!privacyErrors.confpass}
                      helperText={privacyErrors.confpass}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12 }}>
                    <Button type="submit" variant="contained" className="button-variant-contained" sx={{ textTransform: 'none' }}>
                      Update password
                    </Button>
                  </Grid2>
                </Grid2>
              </Box>
            </TabPanel>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default User_Profile;
